import { useSelector } from 'react-redux';
import { withAuthentication } from '../../common/authentication';
import { UploadPageProps } from './interfaces';
import { Header } from '../../features/header/Header';
import { Footer } from '../../features/footer/Footer';
import Body from './Body';
import Alerts from './Alerts';
import { IngestState } from '../../features/ingest/ingestSlice';
import { AlertsState } from '../../features/alerts/alertsSlice';

export default withAuthentication((props: UploadPageProps) => {
  const ingest = useSelector((state: any) => state.ingest) as IngestState;
  const alerts = useSelector((state: any) => state.alerts) as AlertsState;
  return (
    <>
      <Header />
      <Body {...ingest} />
      <Footer />
      <Alerts {...alerts} />
    </>
  );
});
